export default "__VITE_ASSET__b439295e__"